import Service from '@/api/Service'

const project = {
    state: {
        count: "",
        projectList: [],
        projectInfo: {},
    },
    mutations: {
        SET_COUNT: (state, count) => {
            state.count = count
        },
        SET_PROJECTLIST: (state, list) => {
            state.projectList = list
        },
        SET_PROJECTINFO: (state, projectInfo) => {
            state.projectInfo = projectInfo
        },
    },
    actions: {
        // 获取项目列表
        async GetProjectList({ commit }, parms) {
            let data = await Service.getProjectList(parms);
            return new Promise((resolve, reject) => {
                if (data) {
                    let list = data.list === null ? [] : data.list;
                    commit('SET_COUNT',data.count)
                    commit('SET_PROJECTLIST', list)
                    resolve()
                }else{
                    reject()
                }
            })
        },
        // 获取当前项目信息
        async GetProjectInfo({ commit }, parms) {
            let data = await Service.getProjectInfo(parms);
            return new Promise((resolve, reject) => {
                if (data) {
                    commit('SET_PROJECTINFO', data)
                    resolve(data)
                } else {
                    reject("no projectId")
                }
            })
        }
    }
}

export default project
